import { render, staticRenderFns } from "./optimizingLawyer.vue?vue&type=template&id=1825664c&scoped=true&"
import script from "./optimizingLawyer.vue?vue&type=script&lang=js&"
export * from "./optimizingLawyer.vue?vue&type=script&lang=js&"
import style0 from "./optimizingLawyer.vue?vue&type=style&index=0&id=1825664c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1825664c",
  null
  
)

export default component.exports